import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';
import { IconWarning } from 'src/easyclaim.app.assets';

import { Slider } from './Slider';

import styles from './styles/DeletePhotoConfirmationSlider.module.css';

interface DeletePhotoConfirmationSliderProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export const DeletePhotoConfirmationSlider = ({
	isOpen,
	onClose,
	onConfirm,
}: DeletePhotoConfirmationSliderProps) => {
	return createPortal(
		<Slider
			isOpen={isOpen}
			onClose={onClose}
			title={<FormattedMessage id="photo.deleteConfirmation.title" />}
		>
			<div className={styles.content} data-delete-photo-confirmation>
				<IconWarning className={styles.warningIcon} aria-hidden="true" />
				<p className={styles.description}>
					<FormattedMessage id="photo.deleteConfirmation.description" />
				</p>
				<div className={styles.actions}>
					<button
						className={styles.confirmButton}
						onClick={(event) => {
							event.stopPropagation();
							onConfirm();
						}}
					>
						<FormattedMessage id="photo.deleteConfirmation.confirm" />
					</button>
					<button
						className={styles.cancelButton}
						onClick={(event) => {
							event.stopPropagation();
							onClose();
						}}
					>
						<FormattedMessage id="photo.deleteConfirmation.cancel" />
					</button>
				</div>
			</div>
		</Slider>,
		document.body
	);
};
